import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import Logo from '../components/common/Logo';

const Login = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });

    const { email, password } = formData;
    const { login, user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (user) {
            navigate('/');
        }
    }, [user, navigate]);

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
        }));
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        try {
            await login(formData);
        } catch (error) {
            console.error(error);
            alert('Échec de la connexion');
        }
    };

    return (
        <div className="auth-container page-transition">
            <div className="auth-card">
                <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '12px' }}>
                        <Logo size="large" showText={false} variant="auth" />
                    </div>
                    <p className="auth-subtitle">Heureux de vous revoir !</p>
                </div>

                <form onSubmit={onSubmit}>
                    <div className="input-group">
                        <label className="input-label" htmlFor="email">Email</label>
                        <input
                            type="email"
                            className="input-field"
                            id="email"
                            name="email"
                            value={email}
                            placeholder="Entrez votre email"
                            onChange={onChange}
                        />
                    </div>

                    <div className="input-group" style={{ marginBottom: '30px' }}>
                        <label className="input-label" htmlFor="password">Mot de passe</label>
                        <input
                            type="password"
                            className="input-field"
                            id="password"
                            name="password"
                            value={password}
                            placeholder="Entrez votre mot de passe"
                            onChange={onChange}
                        />
                    </div>

                    <button type="submit" className="btn btn-primary" style={{ width: '100%', padding: '15px' }}>
                        Se connecter
                    </button>
                </form>

                <div className="auth-footer" style={{ textAlign: 'center', marginTop: '16px' }}>
                    <Link to="/forgot-password" style={{ color: 'var(--primary)', textDecoration: 'none', fontSize: '14px' }}>
                        Mot de passe oublié ?
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Login;
